/**
 * FormField Component
 *
 * Wrapper for form inputs with label, error, and help text
 * - Consistent label styling
 * - Error message display
 * - Optional help text
 * - Required indicator
 */

import React from "react";
import PropTypes from "prop-types";
import "./FormField.scss";

export const FormField = ({
  label,
  children,
  error,
  helpText,
  required = false,
  htmlFor,
  className = "",
}) => {
  const fieldClasses = ["form-field", error && "form-field--error", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={fieldClasses}>
      {label && (
        <label className="form-field__label" htmlFor={htmlFor}>
          {label}
          {required && <span className="form-field__required">*</span>}
        </label>
      )}
      <div className="form-field__control">{children}</div>
      {error && <div className="form-field__error">{error}</div>}
      {helpText && !error && <div className="form-field__help">{helpText}</div>}
    </div>
  );
};

FormField.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
  error: PropTypes.string,
  helpText: PropTypes.string,
  required: PropTypes.bool,
  htmlFor: PropTypes.string,
  className: PropTypes.string,
};

export default FormField;
